import { render, staticRenderFns } from "./SettingValidateRuleDialog.vue?vue&type=template&id=21dab492&scoped=true&"
import script from "./SettingValidateRuleDialog.vue?vue&type=script&lang=js&"
export * from "./SettingValidateRuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingValidateRuleDialog.vue?vue&type=style&index=0&id=21dab492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dab492",
  null
  
)

export default component.exports